// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageCarousel_imageContainer__VaYym","image":"ImageCarousel_image__dYDdK"};